import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "skill-container"
};
const _hoisted_2 = {
  key: 0,
  class: "path-desc"
};
const _hoisted_3 = {
  class: "skilled-box"
};
const _hoisted_4 = {
  key: 0,
  class: "skilled-path"
};
const _hoisted_5 = {
  key: 0,
  class: "separator"
};
const _hoisted_6 = {
  key: 1,
  class: "over-limit-box"
};
const _hoisted_7 = {
  class: "over-limit-path"
};
import { ref, computed, onMounted } from 'vue';
import { ElRow } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from '@/store';
import { inApostleType, isValid, parseToCostDesc } from '@/tools/utils';
import 'element-plus/es/components/progress/style/css'; // pre-declaration

export default {
  __name: 'QuickSkillPreviewCard',
  props: {
    skillId: {
      type: Number,
      required: true
    }
  },

  setup(__props) {
    const props = __props; // refs

    const data = ref(null); // computed

    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    });
    const ticketRole = computed(() => store.state.stage_role ?? null); // functions

    const getSkillDesc = item => {
      const sectsName = item.sects.name;
      const isPrivate = item.is_private ? '秘传' : '';
      const degreeLevel = `${item.degree}级`;
      const skillType = isValid(item.skill_type) ? item.skill_type.desc : '不明';
      const conventional = item.conventional ? '常规施法' : '构筑施法';
      const powerType = isValid(item.power_type) ? item.power_type.desc : '不明';
      let skillDesc = `${sectsName} · ${degreeLevel}${isPrivate} · ${powerType} · ${skillType} · ${conventional}`;

      if (inApostleType(userType.value)) {
        return `${skillDesc} · 神秘${item.mysterious_level}`;
      }

      return skillDesc;
    };

    const getData = () => {
      if (!ticketRole.value) return null;
      let cachedData = false;

      if (ticketRole.value.skill_data) {
        const buffer = ticketRole.value.skill_data.filter(item => item.id === props.skillId);

        if (buffer.length !== 0) {
          data.value = buffer[0];
          cachedData = true;
        }
      }

      if (!cachedData) {
        request('skills/role_skills/get/', {
          'role_skill_id': props.skillId
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            data.value = response.data;
            let buffer = structuredClone(ticketRole.value);
            let skillData = buffer.skill_data ?? [];
            skillData.push(response.data);
            buffer.skill_data = skillData;
            buffer.id = parseInt(ticketRole.value.id);
            store.commit('update_stage_role', buffer);
          }
        });
      }
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), data.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_createElementVNode("text", null, [_createElementVNode("b", null, _toDisplayString(getSkillDesc(data.value)), 1)])]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [data.value.skilled_path || data.value.over_limit_path ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [data.value.skilled_path ? (_openBlock(), _createElementBlock("text", _hoisted_4, " 专精途径：" + _toDisplayString(data.value.skilled_path), 1)) : _createCommentVNode("", true)]), data.value.over_limit_path ? (_openBlock(), _createElementBlock("text", _hoisted_5, "/")) : _createCommentVNode("", true), data.value.over_limit_path ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("text", _hoisted_7, " 超限途径：" + _toDisplayString(data.value.over_limit_path), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
        _: 1
      }), _unref(isValid)(data.value.timing_type) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, [_cache[0] || (_cache[0] = _createTextVNode("发动时机    ", -1)), _createElementVNode("b", null, _toDisplayString(data.value.timing_type.desc), 1)])]),
        _: 1
      })) : _createCommentVNode("", true), _unref(isValid)(data.value.cooldown) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 1,
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, [_cache[1] || (_cache[1] = _createTextVNode("技能冷却    ", -1)), _createElementVNode("b", null, _toDisplayString(data.value.cooldown.desc), 1)])]),
        _: 1
      })) : _createCommentVNode("", true), _unref(isValid)(data.value.cost) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 2,
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, [_cache[2] || (_cache[2] = _createTextVNode("技能消耗    ", -1)), _createElementVNode("b", null, _toDisplayString(_unref(parseToCostDesc)(data.value['cost'])), 1)])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_unref(ElRow), {
        class: "skill-desc"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(data.value['desc']), 1)]),
        _: 1
      }), _unref(isValid)(data.value.deep_desc) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 3,
        class: "skill-deep-desc"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(data.value['deep_desc']), 1)]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
    };
  }

};